import React, { Component } from 'react';
import $ from 'jquery';
import { NavLink, HashRouter } from 'react-router-dom';
import { can } from '../../utils/permissions';

class Nav extends Component {
  componentDidMount = () => {
    $(() => {
      $('body').on('click', evt => {
        if (evt.target.id !== 'menu-button' && evt.target.id !== 'main-menu') {
          $('#menu-button').removeClass('active');
          $('#main-menu').removeClass('opened');
        }
      });

      $('#main-menu li.has-childs > a').click(function(evt) {
        evt.stopPropagation();
        $(this).toggleClass('active');
        $(this)
          .parent()
          .find('ul')
          .stop(true, true)
          .slideToggle();
        return false;
      });
    });
  };

  render() {
    return (
      <HashRouter>
        <nav id="main-menu">
          <ul>
            {can('view-customer') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/Customer" title="Clientes">
                  Clientes
                </NavLink>
              </li>
            )}
            {can('view-module') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/Module" title="Módulos">
                  Módulos
                </NavLink>
              </li>
            )}
            {can('view-user') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/User" title="Usuários">
                  Usuários
                </NavLink>
              </li>
            )}
            {can('view-terms') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/Term" title="Termos de adesão">
                  Termos de adesão
                </NavLink>
              </li>
            )}
            {/* <li className="top-level-item">
              <NavLink to="/Config" title="Configurações do sistema">
                Configurações do sistema
              </NavLink>
            </li> */}
            {can('view-norm') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/Norm" title="Normas">
                  Normas
                </NavLink>
              </li>
            )}
            {can('view-board') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/board-models" title="Modelo de Quadros">
                  Modelo de Quadros
                </NavLink>
              </li>
            )}
            {can('view-videos') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/tutorial-videos" title=" Vídeos Tutoriais">
                  Vídeos Tutoriais
                </NavLink>
              </li>
            )}
            {can('view-plan') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/Plan" title="Planos">
                  Planos
                </NavLink>
              </li>
            )}
            {can('view-wlpartner') && (
              <li className="top-level-item">
                <NavLink className="toggle-menu" to="/Partner" title="Parceiros White Label">
                  Parceiros White Label
                </NavLink>
              </li>
            )}
          </ul>
        </nav>
      </HashRouter>
    );
  }
}

export default Nav;
